import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import mage from './mage.png';
import logo from './logo.png';
import axios from 'axios';
import { format } from 'date-fns';
import { use } from 'react';

const Navbar = () => {

  const [lastLoginDateTime, setLastLoginDateTime] = useState('');
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showAdminDropdown, setShowAdminDropdown] = useState(false);
  const [showReportsDropdown, setShowReportsDropdown] = useState(false);
  const [showFPSRoasterEntry, setShowFPSRoasterEntry] = useState(false);
  const [showCMRRoasterEntry, setShowCMRRoasterEntry] = useState(false);
  const [showTPDSRoasterEntry, setShowTPDSRoasterEntry] = useState(false);
  const [showFPSDropdown, setShowFPSDropdown] = useState(false);
  const [showGoDownDropdownCMR, setShowGoDownDropdownCMR] = useState(false);
  const [showGoDownDropdownTPDS, setShowGoDownDropdownTPDS] = useState(false);
  const [showCmrDropdown, setShowCmrDropdown] = useState(false);
  const [showDashBoardDropdown, setShowDashBoardDropdown] = useState(false);
  const [showQCTPDSDropdown, setShowQCTPDSDropdown] = useState(false);
  const [showQCTPDSReportsDropdown, setShowQCTPDSReportsDropdown] = useState(false);
  const [showQCTPDSAdditionalDropdown, setShowQCTPDSAdditionalDropdown] = useState(false);

  const [showQCDropdown, setShowQCDropdown] = useState(false);
  const [isnavbarOpen, setisnavbarOpen] = useState(false);
  //const [showFPSRoasterEntry, setShowFPSRoasterEntry] = useState(false);
  const [userInfo, setUserInfo] = useState({
    // displayName: '',
    // empId: ''
    fullName: '',
    employeeId: '',
    roleName: '',
    designation: ''
  });
  //console.log('fullName',userInfo.fullName);
  //console.log('roleName',userInfo.roleName);
  //const token=`${process.env.REACT_APP_AUTH_TOKEN}`;
  const [isLoggedIn, setIsLoggedIn] = useState(false);  // Track login state
  const navigate = useNavigate();
  console.log("Designation raw:", userInfo?.designation);
  console.log("Designation after trim:", (userInfo?.designation ?? "").trim());


  function closeAllDropdowns() {
    setShowUserDropdown(false);
    setShowAdminDropdown(false);
    setShowReportsDropdown(false);
    setShowQCTPDSDropdown(false);
    setShowQCTPDSReportsDropdown(false);
    setShowQCTPDSAdditionalDropdown(false);
    // setShowGoDownDropdown(false);
    // setShowCmrDropdown(false);
  }

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user'));
    const loginTime = localStorage.getItem('loginTime');
    // if (userData) {
    //   setUserInfo({

    //     fullName: userData.fullName,
    //     employeeId: userData.employeeId,
    //   });

    if (userData) {
      // Extract the first name from fullName (only the first word)
      const firstName = userData.fullName.split(' ')[0];

      // Set the state with firstName and employeeId
      setUserInfo({
        fullName: firstName,  // Only first name is considered
        employeeId: userData.employeeId,
        roleName: userData.roleName,
        designation: userData.designation
      });

      setIsLoggedIn(true);
      setLastLoginDateTime(`Last Login: ${format(new Date(loginTime), 'dd-MM-yyyy | hh:mm:ss a')}`);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogout = async () => {
    try {
      // Make API call to logout
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/logout`);  // Your logout API endpoint

      // Clear user data from localStorage
      localStorage.removeItem('user');
      localStorage.removeItem('loginTime');

      // Update login state
      setIsLoggedIn(false);

      // Redirect the user to the login page

      navigate('/userInspection');
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const handleLoginRedirect = () => {
    navigate('/login');  // Navigate to login page if not logged in
  };
  // Close sidebar and dropdown when a menu item is clicked (for small screens)
  const handleMenuItemClick = () => {
    if (window.innerWidth <= 1024) {
      setisnavbarOpen(false); // Close the sidebar on small screens
    }
    setShowFPSDropdown(false); // Close the FPS dropdown when a menu item is clicked
    setShowReportsDropdown(false); // Close the Reports dropdown when a menu item is clicked
    setShowUserDropdown(false); // Close the User dropdown when a menu item is clicked
    setShowAdminDropdown(false); // Close the Admin dropdown when a menu item is clicked
    setShowCmrDropdown(false);
    setShowFPSRoasterEntry(false);
    setShowTPDSRoasterEntry(false);
    setShowCMRRoasterEntry(false);
  };



  return (
    <div className='main-navibar-main' >
      <div>
        <img className="banner" src={mage} alt="Poims_image" />
      </div>
      <div className="navbar navbar-expand-lg navbar-dark">
        <div className="container">
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" onClick={() => setisnavbarOpen(!isnavbarOpen)}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${isnavbarOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav">
              <Link className="navbar-brand ms-2" onClick={handleMenuItemClick} to={isLoggedIn ? "/home" : "/"}>HOME</Link>
              <>
                <li className="nav-item dropdown ms-2">
                  {isLoggedIn && (
                    <>
                      <a className="nav-link dropdown-toggle ms-2" id="userDropdown" role="button"
                        aria-expanded={showUserDropdown ? 'true' : 'false'}
                        onMouseEnter={() => {
                          closeAllDropdowns();
                          setShowUserDropdown(true);
                        }}
                        onMouseLeave={() => {
                          setTimeout(() => {
                            if (!document.getElementById('userMenu').matches(':hover')) {
                              setShowUserDropdown(false);
                            }
                          }, 100);
                        }}
                      >
                        User
                      </a>
                      <ul className={`dropdown-menu ${showUserDropdown ? 'show' : ''}`} aria-labelledby="userDropdown" id="userMenu"
                        onMouseEnter={() => setShowUserDropdown(true)}
                        onMouseLeave={() => setShowUserDropdown(false)}
                      >
                        <li>
                          <Link className="dropdown-item" to="/changeDisplayName" onClick={handleMenuItemClick}>Change Display Name</Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/changePassword" onClick={handleMenuItemClick}>Change Password</Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/profile" onClick={handleMenuItemClick}>Profile</Link>
                        </li>
                      </ul>
                    </>
                  )}
                </li>
                <li className="nav-item dropdown ms-2">
                  {isLoggedIn && userInfo.roleName === "Admin" && (
                    <>
                      <a className="nav-link dropdown-toggle ms-2" id="adminDropdown" role="button"
                        aria-expanded={showAdminDropdown ? 'true' : 'false'}
                        onMouseEnter={() => {
                          closeAllDropdowns();
                          setShowAdminDropdown(true);
                        }}
                        onMouseLeave={() => {
                          setTimeout(() => {
                            if (!document.getElementById('administrationMenu').matches(':hover')) {
                              setShowAdminDropdown(false);
                            }
                          }, 100);
                        }}
                      >
                        Admin
                      </a>
                      <ul className={`dropdown-menu ${showAdminDropdown ? 'show' : ''}`}
                        aria-labelledby="adminDropdown" id="administrationMenu"
                        onMouseEnter={() => setShowAdminDropdown(true)}
                        onMouseLeave={() => setShowAdminDropdown(false)}
                      >
                        <li>
                          <Link className="dropdown-item" to="/roleMaster" onClick={handleMenuItemClick}>Add Role</Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/serviceMaster" onClick={handleMenuItemClick}>Add Services</Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/roleServiceMap" onClick={handleMenuItemClick}>Role Service Mapping</Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/createUser" onClick={handleMenuItemClick}>Create User</Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/resetPassword" onClick={handleMenuItemClick}>Reset Password</Link>
                        </li>
                        {/* <li>
                          <Link className="dropdown-item" to="/createFPS" onClick={handleMenuItemClick}>Create FPS</Link>
                        </li> */}
                      </ul>
                    </>
                  )}
                </li>
                <li className="nav-item dropdown ms-2">
                  {isLoggedIn && (
                    <>
                      <a
                        className="nav-link dropdown-toggle ms-2"
                        id="fpsDropDown"
                        role="button"
                        aria-expanded={showFPSDropdown ? 'true' : 'false'}
                        onMouseEnter={() => {
                          closeAllDropdowns();
                          setShowFPSDropdown(true);
                        }}
                        onMouseLeave={() => {
                          setTimeout(() => {
                            if (!document.getElementById('fpsMenu').matches(':hover')) {
                              setShowFPSDropdown(false);
                            }
                          }, 100);
                        }}
                      >
                        FPS
                      </a>
                      <ul
                        className={`dropdown-menu ${showFPSDropdown ? 'show' : ''}`}
                        aria-labelledby="fpsDropDown"
                        id="fpsMenu"
                        onMouseEnter={() => setShowFPSDropdown(true)}
                        onMouseLeave={() => setShowFPSDropdown(false)}
                      >
                        <li>
                          <Link className="dropdown-item" to="/home" onClick={handleMenuItemClick}>FPS DashBoard</Link>
                        </li>

                        <li>
                          <Link className="dropdown-item" to="/inspectionAllocation" onClick={handleMenuItemClick}>FPS Roaster Entry</Link>
                        </li>
                        {
                          userInfo.roleName === "Admin" && (
                            <>
                              <li>
                                <Link className="dropdown-item" to="/fpsLatlong" onClick={handleMenuItemClick}>FPS Latitude and Longitude</Link>
                              </li>
                              <li>
                                <Link className="dropdown-item" to="/fpsMasterDataNotPresent" onClick={handleMenuItemClick}>FPS Master Data</Link>
                              </li>
                            </>
                          )
                        }

                        <li>
                          <Link className="dropdown-item" to="/fpsRationEntry" onClick={handleMenuItemClick}>New Ration Cards And Members Entry</Link>
                        </li>

                        {/* <li className="nav-item dropend">

                          <ul
                            className="dropdown-item dropdown-toggle"
                            id="roasterDropDown"
                            role="button"
                            aria-expanded={showFPSRoasterEntry ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowFPSRoasterEntry(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('roasterMenu').matches(':hover')) {
                                  setShowFPSRoasterEntry(false);
                                }
                              }, 100);
                            }}

                          >
                            FPS Roaster
                          </ul>
                          <ul
                            className={`dropdown-menu ${showFPSRoasterEntry ? 'show' : ''}`}
                            aria-labelledby="roasterDropDown"
                            id="roasterMenu"
                            onMouseEnter={() => setShowFPSRoasterEntry(true)}
                            onMouseLeave={() => setShowFPSRoasterEntry(false)}
                            style={{ position: 'absolute', left: '100%', top: 0 }}

                          >
                            <li>
                              <Link className="dropdown-item" to="/inspectionAllocation" onClick={handleMenuItemClick}>FPS Roaster Entry</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/inspectionTeam" onClick={handleMenuItemClick}>FPS Roaster Team</Link>
                            </li>
                          </ul>
                        </li> */}

                        {/* Reports dropdown */}
                        <li className="nav-item dropend">

                          <ul
                            className="dropdown-item dropdown-toggle"
                            id="reportsDropDown"
                            role="button"
                            aria-expanded={showReportsDropdown ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowReportsDropdown(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('reportsMenu').matches(':hover')) {
                                  setShowReportsDropdown(false);
                                }
                              }, 100);
                            }}

                          >
                            Reports
                          </ul>
                          <ul
                            className={`dropdown-menu ${showReportsDropdown ? 'show' : ''}`}
                            aria-labelledby="reportsDropDown"
                            id="reportsMenu"
                            onMouseEnter={() => setShowReportsDropdown(true)}
                            onMouseLeave={() => setShowReportsDropdown(false)}
                            style={{ position: 'absolute', left: '100%', top: 0 }}

                          >
                            <li>
                              <Link className="dropdown-item" to="/fpsInspectionReport" onClick={handleMenuItemClick} >FPS Inspection Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/fpsComplainStatusSummary" onClick={handleMenuItemClick}>FPS Compliance Status Summary</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/summaryOfMonthly" onClick={handleMenuItemClick}> FPS Inspection Summary Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/stockVerificationReport" onClick={handleMenuItemClick}>FPS Stock Verification Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/beneficiaryFeedbackReport" onClick={handleMenuItemClick}>FPS Beneficiary Feedback Report</Link>
                            </li>

                            <li>
                              <Link className="dropdown-item" to="/myTargertReport" onClick={handleMenuItemClick} >My Target Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/inspectionAllocationReport" onClick={handleMenuItemClick}>FPS Inspection Allocation Report</Link>
                            </li>

                            <li>
                              <Link className="dropdown-item" to="/fpsinspectionration" onClick={handleMenuItemClick}>FPS New Ration To Be Issued</Link>
                            </li>

                            <li>
                              <Link className="dropdown-item" to="/fpsNewRationAdded" onClick={handleMenuItemClick}>FPS New Ration Cards Added</Link>
                            </li>


                          </ul>
                        </li>


                        {/* Additional dropdown */}
                        <li className="nav-item dropend">

                          <ul
                            className="dropdown-item dropdown-toggle"
                            id="roasterDropDown"
                            role="button"
                            aria-expanded={showFPSRoasterEntry ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowFPSRoasterEntry(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('roasterMenu').matches(':hover')) {
                                  setShowFPSRoasterEntry(false);
                                }
                              }, 100);
                            }}

                          >
                            Additional Reports
                          </ul>
                          <ul
                            className={`dropdown-menu ${showFPSRoasterEntry ? 'show' : ''}`}
                            aria-labelledby="roasterDropDown"
                            id="roasterMenu"
                            onMouseEnter={() => setShowFPSRoasterEntry(true)}
                            onMouseLeave={() => setShowFPSRoasterEntry(false)}
                            style={{ position: 'absolute', left: '100%', top: 0 }}

                          >

                            <li>
                              <Link className="dropdown-item" to="/officerInspectionCounts" onClick={handleMenuItemClick}>Officer Inspection Counts Today</Link>
                            </li>

                            <li>
                              <Link className="dropdown-item" to="/subDivisionsAndAllDistricts" onClick={handleMenuItemClick}>SubDivision wise Inspection Summary</Link>
                            </li>

                            <li>
                              <Link className="dropdown-item" to="/discrepancyReport" onClick={handleMenuItemClick}>Discrepancy Report-1</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/discrepancySubDivisionWise" onClick={handleMenuItemClick}> Discrepancy Report-(ZOD)</Link>
                            </li>
                            {/* Show only if designation is DEO */}
                            {["Sub Divisional Officer", "TEST", "DGM Monitoring & Evaluation"].includes(
                              (userInfo?.designation ?? "").trim()
                            ) && (
                                <>
                                  <li>
                                    <Link className="dropdown-item" to="/existingStockVerificationReport" onClick={handleMenuItemClick}>
                                      FPS ATR Entry Form
                                    </Link>
                                  </li>
                                  <li>
                                    <Link className="dropdown-item" to="/existingStockVerificationUpdation" onClick={handleMenuItemClick}>
                                      FPS ATR Updation Form
                                    </Link>
                                  </li>
                                </>
                              )}
                            <li>
                              <Link className="dropdown-item" to="/atrDetailedReport" onClick={handleMenuItemClick}> FPS ATR Detailed Report </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/actionTakenReport" onClick={handleMenuItemClick}> ATR Report - Zero Office Day </Link>
                            </li>
                            {/*<li>
                              <Link className="dropdown-item" to="/actionTakenUpdate" onClick={handleMenuItemClick}>Beneficiary Feedback  Updation  Report</Link>
                            </li> */}


                          </ul>
                        </li>
                      </ul>
                    </>
                  )}
                </li>
                <li className="nav-item dropdown ms-2">
                  {isLoggedIn && (
                    <>
                      <a className="nav-link dropdown-toggle ms-2" id="godown-CMR" role="button"
                        aria-expanded={showGoDownDropdownCMR ? 'true' : 'false'}
                        onMouseEnter={() => {
                          closeAllDropdowns();
                          setShowGoDownDropdownCMR(true);
                        }}
                        onMouseLeave={() => {
                          setTimeout(() => {
                            if (!document.getElementById('godownMenu-CMR').matches(':hover')) {
                              setShowGoDownDropdownCMR(false);
                            }
                          }, 100);
                        }}
                      //style={{ pointerEvents: 'none',color:'#d3d3d3' }}
                      >
                        CMR
                      </a>
                      <ul className={`dropdown-menu ${showGoDownDropdownCMR ? 'show' : ''}`}
                        aria-labelledby="godown-CMR" id="godownMenu-CMR"
                        onMouseEnter={() => setShowGoDownDropdownCMR(true)}
                        onMouseLeave={() => setShowGoDownDropdownCMR(false)}
                      >
                        <li>
                          <Link className="dropdown-item" to="/cmrDashboard" onClick={handleMenuItemClick} onMouseEnter={() => {
                            closeAllDropdowns();
                            setShowReportsDropdown(false);
                          }} >CMR DashBoard</Link>
                        </li>

                        <li>
                          <Link className="dropdown-item" to="/cmrRoasterEntry" onClick={handleMenuItemClick} onMouseEnter={() => {
                            closeAllDropdowns();
                            setShowReportsDropdown(false);
                          }} >CMR Roaster Entry</Link>
                        </li>
                        {/* <li className="nav-item dropend">

                          <ul
                            className="dropdown-item dropdown-toggle"
                            id="cmrRoasterTeam"
                            role="button"
                            aria-expanded={showCMRRoasterEntry ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowCMRRoasterEntry(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('cmrRoaster').matches(':hover')) {
                                  setShowCMRRoasterEntry(false);
                                }
                              }, 100);
                            }}

                          >
                            CMR Roaster 
                          </ul>
                          <ul
                            className={`dropdown-menu ${showCMRRoasterEntry ? 'show' : ''}`}
                            aria-labelledby="cmrRoasterTeam"
                            id="cmrRoaster"
                            onMouseEnter={() => setShowCMRRoasterEntry(true)}
                            onMouseLeave={() => setShowCMRRoasterEntry(false)}
                            style={{ position: 'absolute', left: '100%', top: 0 }}

                          >
                            <li>
                              <Link className="dropdown-item" to="/cmrRoasterEntry" onClick={handleMenuItemClick} onMouseEnter={() => {
                                closeAllDropdowns();
                                setShowReportsDropdown(false);
                              }} >CMR Roaster Entry</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/cmrRoasterTeam" onClick={handleMenuItemClick}onMouseEnter={() => {
                                closeAllDropdowns();
                                setShowReportsDropdown(false);
                              }}>CMR Roaster Team</Link>
                            </li>
                          </ul>
                        </li> */}




                        {/* --------------------CMR----------------------------- */}
                        <li className="nav-item dropend">

                          <ul
                            className="dropdown-item dropdown-toggle"
                            id="cmrDropDown"
                            role="button"
                            aria-expanded={showCmrDropdown ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowCmrDropdown(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('cmrMenu').matches(':hover')) {
                                  setShowCmrDropdown(false);
                                }
                              }, 1);
                            }}

                          >
                            CMR Reports
                          </ul>
                          <ul
                            className={`dropdown-menu ${showCmrDropdown ? 'show' : ''}`}
                            aria-labelledby="cmrDropDown"
                            id="cmrMenu"
                            onMouseEnter={() => setShowCmrDropdown(true)}
                            onMouseLeave={() => setShowCmrDropdown(false)}
                            style={{ position: 'absolute', left: '100%', top: 0 }}

                          >
                            <li>
                              <Link
                                className="dropdown-item" to="/CmrInspectionReport" onClick={handleMenuItemClick}>CMR Inspection Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/cmrComplianceStatusSummary" onClick={handleMenuItemClick}>CMR Compliance Status Summary</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/cmrInspectionSummaryReport" onClick={handleMenuItemClick}>CMR Inspection Summary Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/cmrStockReport" onClick={handleMenuItemClick}>CMR Stock Verification Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/cmrGrainSampleFeedback" onClick={handleMenuItemClick}>CMR Grain Sample Feedback Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/cmrMyTargetReport" onClick={handleMenuItemClick}>CMR My Target Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/cmrInspectionAllocationReport" onClick={handleMenuItemClick}>CMR InspectionAllocationReport</Link>
                            </li>

                            {/* <li>
                              <Link className="dropdown-item" to="/cmrRoasterTeam" onClick={handleMenuItemClick}>CMR Roaster Team</Link>
                            </li> */}





                          </ul>
                        </li>


                        <li className="nav-item dropend">

                          <ul
                            className="dropdown-item dropdown-toggle"
                            id="cmrRoasterTeam"
                            role="button"
                            aria-expanded={showCMRRoasterEntry ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowCMRRoasterEntry(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('cmrRoaster').matches(':hover')) {
                                  setShowCMRRoasterEntry(false);
                                }
                              }, 100);
                            }}

                          >
                            Additional Reports
                          </ul>
                          <ul
                            className={`dropdown-menu ${showCMRRoasterEntry ? 'show' : ''}`}
                            aria-labelledby="cmrRoasterTeam"
                            id="cmrRoaster"
                            onMouseEnter={() => setShowCMRRoasterEntry(true)}
                            onMouseLeave={() => setShowCMRRoasterEntry(false)}
                            style={{ position: 'absolute', left: '100%', top: 0 }}

                          >

                            <li>
                              <Link className="dropdown-item" to="/cmrDiscrepancyReport" onClick={handleMenuItemClick} onMouseEnter={() => {
                                closeAllDropdowns();
                                setShowReportsDropdown(false);
                              }}>CMR Discrepancy Report</Link>
                            </li>
                            {["DM SFC", "TEST", "GM Procurement", "CGM Procurement", "DGM Monitoring & Evaluation"].includes(
                              (userInfo?.designation ?? "").trim()
                            ) && (
                                <>
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/cmrAtrEntryForm"
                                      onClick={handleMenuItemClick}
                                      onMouseEnter={() => {
                                        closeAllDropdowns();
                                        setShowReportsDropdown(false);
                                      }}
                                    >
                                      CMR ATR Entry Form
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/cmrAtrUpdationForm"
                                      onClick={handleMenuItemClick}
                                      onMouseEnter={() => {
                                        closeAllDropdowns();
                                        setShowReportsDropdown(false);
                                      }}
                                    >
                                      CMR ATR Updation Form
                                    </Link>
                                  </li>
                                </>
                              )}
                            <li>
                              <Link className="dropdown-item" to="/cmrDetailedReport" onClick={handleMenuItemClick} onMouseEnter={() => {
                                closeAllDropdowns();
                                setShowReportsDropdown(false);
                              }}>CMR ATR Detailed Report</Link>
                            </li>
                          </ul>
                        </li>


                        <li className="nav-item dropend">

                          {/* <ul
                            className="dropdown-item dropdown-toggle"
                            id="godownDropDown"
                            role="button"
                            aria-expanded={showReportsDropdown ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowReportsDropdown(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('godownMenu').matches(':hover')) {
                                  setShowReportsDropdown(false);

                                }
                              }, 1);
                            }}
                            style={{ pointerEvents: 'none',color:'#d3d3d3' }}
                          >
                            TPDS Reports
                          </ul> */}
                          <ul
                          // className={`dropdown-menu ${showReportsDropdown ? 'show' : ''}`}
                          // aria-labelledby="godownDropDown"
                          // id="godownMenu"
                          // onMouseEnter={() => setShowReportsDropdown(true)}
                          // onMouseLeave={() => setShowReportsDropdown(false)}
                          // style={{ position: 'absolute', left: '100%', top: 0 }}

                          >
                            {/* <li>
                              <Link
                                className="dropdown-item" to="/tpdsInspectionReport" onClick={handleMenuItemClick}>TPDS Inspection Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsComplaintStatusSummary" onClick={handleMenuItemClick}>TPDS Compliance Status Summary</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsInspectionSummary" onClick={handleMenuItemClick}>TPDS Inspection Summary Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsStockVerificationReport" onClick={handleMenuItemClick}>TPDS Stock Verification Report</Link>
                            </li> */}
                            {/*<li>
                            <Link className="dropdown-item" to="/godownBeneficiaryFeedbackReport" onClick={handleMenuItemClick}>Godown Beneficiary Feedback Report</Link>
                            </li>
                            <li>
                            <Link className="dropdown-item" to="/godownInspectionAllocationReport" onClick={handleMenuItemClick}>Godown Inspection Allocation Report</Link>
                            </li> */}


                          </ul>
                        </li>
                      </ul>
                    </>
                  )}
                </li>
                <li className="nav-item dropdown ms-2">
                  {isLoggedIn && (
                    <>
                      <a className="nav-link dropdown-toggle ms-2" id="godown-TPDS" role="button"
                        aria-expanded={showGoDownDropdownTPDS ? 'true' : 'false'}
                        onMouseEnter={() => {
                          closeAllDropdowns();
                          setShowGoDownDropdownTPDS(true);
                        }}
                        onMouseLeave={() => {
                          setTimeout(() => {
                            if (!document.getElementById('godownMenu-TPDS').matches(':hover')) {
                              setShowGoDownDropdownTPDS(false);
                            }
                          }, 100);
                        }}

                      >
                        TPDS
                      </a>
                      <ul className={`dropdown-menu ${showGoDownDropdownTPDS ? 'show' : ''}`}
                        aria-labelledby="godown-TPDS" id="godownMenu-TPDS"
                        onMouseEnter={() => setShowGoDownDropdownTPDS(true)}
                        onMouseLeave={() => setShowGoDownDropdownTPDS(false)}
                      >
                        <li>
                          <Link className="dropdown-item" to="/tpdsDashboard" onClick={handleMenuItemClick} onMouseEnter={() => {
                            closeAllDropdowns();
                            setShowReportsDropdown(false);
                          }} >TPDS DashBoard</Link>
                        </li>

                        <li>
                          <Link className="dropdown-item" to="/tpdsRoasterEntry" onClick={handleMenuItemClick} onMouseEnter={() => {
                            closeAllDropdowns();
                            setShowReportsDropdown(false);
                          }} >TPDS Roaster Entry</Link>
                        </li>


                        <li className="nav-item dropend">

                          <ul
                            className="dropdown-item dropdown-toggle"
                            id="godownDropDownTPDS"
                            role="button"
                            aria-expanded={showReportsDropdown ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowReportsDropdown(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('godownMenuTPDS').matches(':hover')) {
                                  setShowReportsDropdown(false);

                                }
                              }, 1);
                            }}

                          >
                            TPDS Reports
                          </ul>
                          <ul
                            className={`dropdown-menu ${showReportsDropdown ? 'show' : ''}`}
                            aria-labelledby="godownDropDownTPDS"
                            id="godownMenuTPDS"
                            onMouseEnter={() => setShowReportsDropdown(true)}
                            onMouseLeave={() => setShowReportsDropdown(false)}
                            style={{ position: 'absolute', left: '100%', top: 0 }}

                          >
                            <li>
                              <Link
                                className="dropdown-item" to="/tpdsInspectionReport" onClick={handleMenuItemClick}>TPDS Inspection Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsComplaintStatusSummary" onClick={handleMenuItemClick}>TPDS Compliance Status Summary</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsInspectionSummary" onClick={handleMenuItemClick}>TPDS Inspection Summary Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsStockVerificationReport" onClick={handleMenuItemClick}>TPDS Stock Verification Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsBeneficiaryFeedbackReport" onClick={handleMenuItemClick}>TPDS Grain Sample Feedback Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsMyTargetReport" onClick={handleMenuItemClick}>TPDS My Target Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsInspectionAllocationReport" onClick={handleMenuItemClick}>TPDS Inspection Allocation Report</Link>
                            </li>
                            {/* <li>
                              <Link className="dropdown-item" to="/tpdsRoasterTeam" onClick={handleMenuItemClick}>TPDS  Allocation Team</Link>
                            </li> */}


                          </ul>
                        </li>

                        <li className="nav-item dropend">

                          <ul
                            className="dropdown-item dropdown-toggle"
                            id="tpdsRoasterTeam"
                            role="button"
                            aria-expanded={showTPDSRoasterEntry ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowTPDSRoasterEntry(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('tpdsRoaster').matches(':hover')) {
                                  setShowTPDSRoasterEntry(false);
                                }
                              }, 100);
                            }}

                          >
                            Additional Reports
                          </ul>
                          <ul
                            className={`dropdown-menu ${showTPDSRoasterEntry ? 'show' : ''}`}
                            aria-labelledby="tpdsRoasterTeam"
                            id="tpdsRoaster"
                            onMouseEnter={() => setShowTPDSRoasterEntry(true)}
                            onMouseLeave={() => setShowTPDSRoasterEntry(false)}
                            style={{ position: 'absolute', left: '100%', top: 0 }}

                          >
                            <li>
                              <Link className="dropdown-item" to="/tpdsDiscrepancyReport" onClick={handleMenuItemClick} onMouseEnter={() => {
                                closeAllDropdowns();
                                setShowReportsDropdown(false);
                              }} >TPDS Discrepancy Report</Link>
                            </li>
                            {["DM SFC", "TEST", "GM TPDS", "CGM TPDS", "DGM Monitoring & Evaluation"].includes(
                              (userInfo?.designation ?? "").trim()
                            ) && (
                                <>
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/tpdsATREntryForm"
                                      onClick={handleMenuItemClick}
                                      onMouseEnter={() => {
                                        closeAllDropdowns();
                                        setShowReportsDropdown(false);
                                      }}
                                    >
                                      TPDS ATR Entry Form
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/tpdsATRUpdateForm"
                                      onClick={handleMenuItemClick}
                                      onMouseEnter={() => {
                                        closeAllDropdowns();
                                        setShowReportsDropdown(false);
                                      }}
                                    >
                                      TPDS ATR Updation Form
                                    </Link>
                                  </li>
                                </>
                              )}
                            <li>
                              <Link className="dropdown-item" to="/tpdsDetailedReport" onClick={handleMenuItemClick} onMouseEnter={() => {
                                closeAllDropdowns();
                                setShowReportsDropdown(false);
                              }} >TPDS ATR Detailed Report</Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </>
                  )}
                </li>

                {/* QC-CMR */}

                <li className="nav-item dropdown ms-2">
                  {isLoggedIn && (
                    <>
                      <a className="nav-link dropdown-toggle ms-2" id="godownQC" role="button"
                        aria-expanded={showQCDropdown ? 'true' : 'false'}
                        onMouseEnter={() => {
                          closeAllDropdowns();
                          setShowQCDropdown(true);
                        }}
                        onMouseLeave={() => {
                          setTimeout(() => {
                            if (!document.getElementById('godownMenuQC').matches(':hover')) {
                              setShowQCDropdown(false);
                            }
                          }, 100);
                        }}

                      >
                        QC-CMR
                      </a>
                      <ul className={`dropdown-menu ${showQCDropdown ? 'show' : ''}`}
                        aria-labelledby="godownQC" id="godownMenuQC"
                        onMouseEnter={() => setShowQCDropdown(true)}
                        onMouseLeave={() => setShowQCDropdown(false)}
                      >
                        <li>
                          <Link className="dropdown-item" to="/qcCmrDashboard" onClick={handleMenuItemClick} onMouseEnter={() => {
                            closeAllDropdowns();
                            setShowReportsDropdown(false);
                          }} >QC-CMR DashBoard</Link>
                        </li>

                        {/* <li>
                          <Link className="dropdown-item" to="/tpdsRoasterEntry" onClick={handleMenuItemClick} onMouseEnter={() => {
                            closeAllDropdowns();
                            setShowReportsDropdown(false);
                          }} >QC Roaster Entry</Link>
                        </li> */}


                        <li className="nav-item dropend">

                          <ul
                            className="dropdown-item dropdown-toggle"
                            id="QCDropdowns"
                            role="button"
                            aria-expanded={showReportsDropdown ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowReportsDropdown(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('godownMenuQC').matches(':hover')) {
                                  setShowReportsDropdown(false);

                                }
                              }, 1);
                            }}

                          >
                            QC-CMR Reports
                          </ul>
                          <ul
                            className={`dropdown-menu ${showReportsDropdown ? 'show' : ''}`}
                            aria-labelledby="QCDropdowns"
                            id="godownMenuQC"
                            onMouseEnter={() => setShowReportsDropdown(true)}
                            onMouseLeave={() => setShowReportsDropdown(false)}
                            style={{ position: 'absolute', left: '100%', top: 0 }}

                          >
                            <li>
                              <Link
                                className="dropdown-item" to="/qcCMRInspection" onClick={handleMenuItemClick}>QC-CMR Inspection Report</Link>
                            </li>
                            {/* <li>
                              <Link className="dropdown-item" to="/tpdsComplaintStatusSummary" onClick={handleMenuItemClick}>TPDS Compliance Status Summary</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsInspectionSummary" onClick={handleMenuItemClick}>TPDS Inspection Summary Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsStockVerificationReport" onClick={handleMenuItemClick}>TPDS Stock Verification Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsBeneficiaryFeedbackReport" onClick={handleMenuItemClick}>TPDS Grain Sample Feedback Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsMyTargetReport" onClick={handleMenuItemClick}>TPDS My Target Report</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/tpdsInspectionAllocationReport" onClick={handleMenuItemClick}>TPDS Inspection Allocation Report</Link>
                            </li> */}
                            {/* <li>
                              <Link className="dropdown-item" to="/tpdsRoasterTeam" onClick={handleMenuItemClick}>TPDS  Allocation Team</Link>
                            </li> */}


                          </ul>
                        </li>

                        <li className="nav-item dropend">

                          <ul
                            className="dropdown-item dropdown-toggle"
                            id="qcRoasterTeam"
                            role="button"
                            aria-expanded={showTPDSRoasterEntry ? 'true' : 'false'}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowTPDSRoasterEntry(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                if (!document.getElementById('qcRoaster').matches(':hover')) {
                                  setShowTPDSRoasterEntry(false);
                                }
                              }, 100);
                            }}

                          >
                            QC-CMR Additional Reports
                          </ul>
                          <ul
                            className={`dropdown-menu ${showTPDSRoasterEntry ? 'show' : ''}`}
                            aria-labelledby="qcRoasterTeam"
                            id="qcRoaster"
                            onMouseEnter={() => setShowTPDSRoasterEntry(true)}
                            onMouseLeave={() => setShowTPDSRoasterEntry(false)}
                            style={{ position: 'absolute', left: '100%', top: 0 }}

                          >

                            {["Quality Controller", "DM SFC", "TEST", "GM Procurement", "CGM Procurement", "DGM Monitoring & Evaluation", "IT Manager"].includes(
                              (userInfo?.designation ?? "").trim()
                            ) && (
                                <>
                                  <li>
                                    <Link className="dropdown-item" to="/qcCMRiceDiscrepancy" onClick={handleMenuItemClick} onMouseEnter={() => {
                                      closeAllDropdowns();
                                      setShowReportsDropdown(false);
                                    }} >QC-CMR Rice Discrepancy Report</Link>
                                  </li>
                                  
                                  {/* <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/qcCMRATREntry"
                                      onClick={handleMenuItemClick}
                                      onMouseEnter={() => {
                                        closeAllDropdowns();
                                        setShowReportsDropdown(false);
                                      }}
                                    >
                                      QC-CMR Rice ATR Entry Form
                                    </Link>
                                  </li>

                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/qcCMRATRUpdate"
                                      onClick={handleMenuItemClick}
                                      onMouseEnter={() => {
                                        closeAllDropdowns();
                                        setShowReportsDropdown(false);
                                      }}
                                    >
                                      QC-CMR Rice ATR Updation Form
                                    </Link>
                                  </li> */}



                                  <li>
                                    <Link className="dropdown-item" to="/qcCMRWheatDiscrepancy" onClick={handleMenuItemClick} onMouseEnter={() => {
                                      closeAllDropdowns();
                                      setShowReportsDropdown(false);
                                    }} >QC-CMR Wheat Discrepancy Report</Link>
                                  </li>
                                  {/* <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/qcCMRWhATREntryForm"
                                      onClick={handleMenuItemClick}
                                      onMouseEnter={() => {
                                        closeAllDropdowns();
                                        setShowReportsDropdown(false);
                                      }}
                                    >
                                      QC-CMR Wheat ATR Entry Form
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      to="/qcCMRWhATRUpdateForm"
                                      onClick={handleMenuItemClick}
                                      onMouseEnter={() => {
                                        closeAllDropdowns();
                                        setShowReportsDropdown(false);
                                      }}
                                    >
                                      QC-CMR Wheat ATR Updation Form
                                    </Link>
                                  </li> */}



                                </>
                              )}

                          </ul>
                        </li>
                      </ul>
                    </>
                  )}
                </li>



                {/* QC-TPDS */}

                {/* QC-TPDS */}
                <li className="nav-item dropdown ms-2">
                  {isLoggedIn && (
                    <>
                      {/* ----- MAIN TRIGGER ----- */}
                      <a
                        className="nav-link dropdown-toggle ms-2"
                        id="godownQC-TPDS"
                        role="button"
                        aria-expanded={showQCTPDSDropdown}
                        onMouseEnter={() => {
                          closeAllDropdowns();               // close other top-level menus
                          setShowQCTPDSDropdown(true);
                        }}
                        onMouseLeave={() => {
                          setTimeout(() => {
                            if (!document.getElementById('godownMenuQC-TPDS')?.matches(':hover')) {
                              setShowQCTPDSDropdown(false);
                            }
                          }, 100);
                        }}
                      >
                        QC-TPDS
                      </a>

                      {/* ----- MAIN MENU ----- */}
                      <ul
                        className={`dropdown-menu ${showQCTPDSDropdown ? 'show' : ''}`}
                        aria-labelledby="godownQC-TPDS"
                        id="godownMenuQC-TPDS"
                        onMouseEnter={() => setShowQCTPDSDropdown(true)}
                        onMouseLeave={() => setShowQCTPDSDropdown(false)}
                      >
                        <li>
                          <Link
                            className="dropdown-item"
                            to="/qcTpdsDashboard"
                            onClick={handleMenuItemClick}
                            onMouseEnter={() => {
                              closeAllDropdowns();
                              setShowQCTPDSDropdown(true); 
                            }}
                          >
                            QC-TPDS Dashboard
                          </Link>
                        </li>
                        {/* ---------- QC-TPDS Reports (sub-menu) ---------- */}
                        <li className="nav-item dropend">
                          <a
                            href="#"
                            className="dropdown-item dropdown-toggle"
                            id="qcTpdsReportsDropdown"
                            role="button"
                            aria-expanded={showQCTPDSReportsDropdown}
                            onMouseEnter={() => {
                              setShowQCTPDSReportsDropdown(true);
                              setShowQCTPDSDropdown(true);   // keep parent open
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                const sub = document.getElementById('qcTpdsReportsMenu')?.matches(':hover');
                                const par = document.getElementById('godownMenuQC-TPDS')?.matches(':hover');
                                if (!sub && !par) {
                                  setShowQCTPDSReportsDropdown(false);
                                }
                              }, 150);
                            }}
                            onClick={e => e.preventDefault()}
                          >
                            QC-TPDS Reports
                          </a>

                          <ul
                            className={`dropdown-menu ${showQCTPDSReportsDropdown ? 'show' : ''}`}
                            aria-labelledby="qcTpdsReportsDropdown"
                            id="qcTpdsReportsMenu"
                            onMouseEnter={() => {
                              setShowQCTPDSReportsDropdown(true);
                              setShowQCTPDSDropdown(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                const sub = document.getElementById('qcTpdsReportsMenu')?.matches(':hover');
                                const par = document.getElementById('godownMenuQC-TPDS')?.matches(':hover');
                                if (!sub && !par) setShowQCTPDSReportsDropdown(false);
                              }, 150);
                            }}
                            style={{ position: 'absolute', left: '100%', top: 0 }}
                          >
                            <li>
                              <Link className="dropdown-item" to="/qcTPDSInspection" onClick={handleMenuItemClick}>
                                QC-TPDS Inspection Report
                              </Link>
                            </li>
                          </ul>
                        </li>

                        {/* ---------- QC-TPDS Additional Reports (sub-menu) ---------- */}
                        <li className="nav-item dropend">
                          <a
                            href="#"
                            className="dropdown-item dropdown-toggle"
                            id="qcTpdsAdditionalDropdown"
                            role="button"
                            aria-expanded={showQCTPDSAdditionalDropdown}
                            onMouseEnter={() => {
                              setShowQCTPDSAdditionalDropdown(true);
                              setShowQCTPDSDropdown(true);   // keep parent open
                              setShowQCTPDSReportsDropdown(false);      // ← CLOSE REPORTS

                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                const sub = document.getElementById('qcTpdsAdditionalMenu')?.matches(':hover');
                                const par = document.getElementById('godownMenuQC-TPDS')?.matches(':hover');
                                if (!sub && !par) {
                                  setShowQCTPDSAdditionalDropdown(false);
                                }
                              }, 150);
                            }}
                            onClick={e => e.preventDefault()}
                          >
                            QC-TPDS Additional Reports
                          </a>

                          <ul
                            className={`dropdown-menu ${showQCTPDSAdditionalDropdown ? 'show' : ''}`}
                            aria-labelledby="qcTpdsAdditionalDropdown"
                            id="qcTpdsAdditionalMenu"
                            onMouseEnter={() => {
                              setShowQCTPDSAdditionalDropdown(true);
                              setShowQCTPDSDropdown(true);
                            }}
                            onMouseLeave={() => {
                              setTimeout(() => {
                                const sub = document.getElementById('qcTpdsAdditionalMenu')?.matches(':hover');
                                const par = document.getElementById('godownMenuQC-TPDS')?.matches(':hover');
                                if (!sub && !par) setShowQCTPDSAdditionalDropdown(false);
                              }, 150);
                            }}
                            style={{ position: 'absolute', left: '100%', top: 0 }}
                          >
                            {/* <li>
              <Link className="dropdown-item" to="/qcTpdsDiscrepancyReport" onClick={handleMenuItemClick}>
                QC-TPDS Discrepancy Report
              </Link>
            </li> */}

                            {["Quality Controller", "DM SFC", "TEST", "GM Procurement", "CGM Procurement", "DGM Monitoring & Evaluation", "IT Manager"].includes(
                              (userInfo?.designation ?? "").trim()
                            ) && (
                                <>
                                  <li>
                                    <Link className="dropdown-item" to="/qcTPDSRiceDiscrepancy" onClick={handleMenuItemClick}>
                                      QC-TPDS Rice Discrepancy Report
                                    </Link>
                                  </li>
                                 {/* <li>
                                    <Link className="dropdown-item" to="/qcTpdsATREntryForm" onClick={handleMenuItemClick}>
                                      QC-TPDS Rice ATR Entry Form
                                    </Link>
                                  </li>

                                   <li>
                                    <Link className="dropdown-item" to="/qcTpdsATRUpdateForm" onClick={handleMenuItemClick}>
                                      QC-TPDS Rice ATR Updation Form
                                    </Link>
                                  </li> */}


                                  <li>
                                    <Link className="dropdown-item" to="/qcTPDSWheatDiscrepancy" onClick={handleMenuItemClick}>
                                      QC-TPDS Wheat Discrepancy Report
                                    </Link>
                                  </li>

                                  {/* <li>
                                    <Link className="dropdown-item" to="/qcTPDSWhATREntry" onClick={handleMenuItemClick}>
                                      QC-TPDS Wheat ATR Entry Form
                                    </Link>
                                  </li>
                                  <li>
                                    <Link className="dropdown-item" to="/qcTPDSWhATRUpdate" onClick={handleMenuItemClick}>
                                      QC-TPDS Wheat ATR Updation Form
                                    </Link>
                                  </li> */}


                                </>
                              )}



                          </ul>
                        </li>
                      </ul>
                    </>
                  )}
                </li>



              </>
            </ul>
          </div>
        </div>
        <div className="user-section ">
          {isLoggedIn && (
            <div className="user-info">
              <p className="nameClass">{userInfo.fullName}</p>
              <p className="nameClass"> ({userInfo.employeeId})</p>
            </div>
          )}
          {/* {isLoggedIn && (
            <div className="user-info">
              <p className="nameClass">{lastLoginDateTime}</p>
              <p className="nameClass"> </p>
            </div>
          )} */}
          <button className='button-color' onClick={isLoggedIn ? handleLogout : handleLoginRedirect}>
            {isLoggedIn ? 'LOGOUT' : 'LOGIN'}
          </button>
        </div>
      </div>
      <div className="footer-content-wrapper">
        <div className="footer-paragraph">
          <p className="fixed-1">Copyright&copy; 2024 | All Rights Reserved.</p>
          <p className="fixed-1">
            <Link className="text-a" to="/webSitePolicy">WebSite Policies</Link>
          </p>
          <p className="fixed-2">
            Designed and Developed by{" "}
            <a className='text-a' href="https://www.4gid.com/" target="_blank" rel="noopener noreferrer">
              4G Identity Solutions Pvt. Ltd.
            </a>
          </p>
        </div>

        <div className='logo-image'>
          <img src={logo} className="logoImage" alt="4GLogo" />
        </div>


      </div>

    </div>
  );
};
export default Navbar;
